import { callFunction } from '@/lib/api';

export async function labShareCheck(
  clinicId: string,
  ids: { reportId?: string; messageId?: string; labReportIds?: string[] },
): Promise<boolean> {
  const result = await callFunction<
    Record<string, unknown>,
    { allowed: boolean }
  >('communicate-lab-import', {
    action: 'share-check',
    clinic_id: clinicId,
    ...(ids.reportId ? { report_id: ids.reportId } : {}),
    ...(ids.messageId ? { message_id: ids.messageId } : {}),
    ...(ids.labReportIds && ids.labReportIds.length > 0
      ? { lab_report_ids: ids.labReportIds }
      : {}),
  });
  return result.allowed;
}
